import { IFontData, IPagePrimaryElement, WidgetPlaceType } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface IStoreSubscriptionsWidgetData extends IPagePrimaryElement {
    readonly type: "StoreSubscriptionsWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    style: IStoreSubscriptionsWidgetStyle;
}

export interface IStoreSubscriptionsWidgetStyle extends IAnimatedWidget {
    font: IFontData;
}

export interface IStoreSubscriptionsRenderingData {
    style: IStoreSubscriptionsWidgetStyle;
}

export abstract class StoreSubscriptionsWidgetData {

    public static get defaultData(): IStoreSubscriptionsWidgetData {
        return {
            type: "StoreSubscriptionsWidget",
            placeType: "Section",
            primaryElement: true,
            style: this.defaultStyle
        };
    }

    public static get defaultStyle(): IStoreSubscriptionsWidgetStyle {
        return {
            font: {
                family: "Open Sans",
                weight: "400"
            },
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

    public static localScriptRerenderNeeded(leftHandSide?: IStoreSubscriptionsWidgetData, rightHandSide?: IStoreSubscriptionsWidgetData): boolean {
        return leftHandSide?.id !== rightHandSide?.id;
    }

}